import React from "react";
import { UserFAQdata } from "./tempUserFAQdata";

class UserFAQScene extends React.Component {
  
  renderItem = (item, index) => {
    if (item.link) {
        const strArray = item.answer.split(" ");
        const part1 = strArray.slice(0, item.wordIndex - 1);
        const part2 = strArray.slice(item.wordIndex);
        const linkTxt = strArray[item.wordIndex - 1];
        const link = (
            <a href={item.link} target="_blank">
                {linkTxt}
            </a>
        );

        return (
            <div className ="userfaq-section">
                <div className ="userfaq-question">{item.question}</div>
                <div className ="userfaq-answer">{part1.join(" ")} {link} {part2.join(" ")}</div>
            </div>
        );

    } else {
        return (
            <div className="userfaq-section">
                <div className="userfaq-question">{item.question}</div>
                <div className="userfaq-answer">{item.answer}</div>
            </div>
        );
    }
  };

  onClickStart = () => {
    window.open("https://trybesl.typeform.com/to/nyjnzF3P", "_blank");
  };
  render() {
    const content = UserFAQdata.map((item, index) => {
      return this.renderItem(item, index);
    });
    return (
      <div className="userfaq-container">
        <div className="navbar-section">
          <div className="navbar-content">
            <a href="/" style={{ textDecoration: "none" }}>
              <div className="logo-container">
                <img
                  className="logo-img"
                  src={require("../../images/trybe-logo-white.svg")}
                />
                <div className="logo-text">TRYBE</div>
              </div>
            </a>
            <div className="right-nav-bar">
              <a href='/faqs' className="nav-text-clickable" style={{textDecoration: 'none'}}>
                 FAQ
              </a>
              <div className="nav-text-clickable" onClick={this.onClickStart}>
                APPLY NOW
              </div>
            </div>
          </div>
        </div>
        <div className="main-body">{content}</div>
      </div>
    );
  }
}

module.exports = UserFAQScene;



// WEBPACK FOOTER //
// ./src/components/pages/UserFAQs.js